import React, { FC, Suspense } from 'react'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import { TInterIconView } from '../types/InterSvgIcon.types'

export const InterSvgIconView: FC<TInterIconView> = ({ borderRadius, importedIcon }) => (
  <Suspense fallback={<Skeleton width="24px" height="24px" style={{ borderRadius }} />}>
    {importedIcon}
  </Suspense>
)
